// import React from 'react'
// import Letter from '../Newsletter/Letter'
// import Query from '../Popup_Query/Query'
// const Destination = () => {
//   return (
//     <div>
//   <div class="">
// <Query/>
// <section class="page-banner-area pt-50 pb-35 rel z-1 bgs-cover" style={{backgroundImage: "url('https://images.unsplash.com/photo-1497302347632-904729bc24aa?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')"}}>
//     <div class="container">
//         <div class="banner-inner text-white mb-50">
//             <h2 class="page-title mb-10" data-aos="fade-left" data-aos-duration="1500" data-aos-offset="50">Destination </h2>
//             <nav aria-label="breadcrumb">
//                 <ol class="breadcrumb justify-content-center mb-20" data-aos="fade-right" data-aos-delay="200" data-aos-duration="1500" data-aos-offset="50">
//                     <li class="breadcrumb-item"><a href="/">Home</a></li>
//                     <li class="breadcrumb-item active">Destination</li>
//                 </ol>
//             </nav>
//         </div>
//     </div>
// </section>
// <section class="destinations-page-area pt-95 pb-90 rel z-1">
//     <div class="container">
//         <div class="row justify-content-center">
//             <div class="col-lg-12">
//                 <div class="section-title text-center counter-text-wrap mb-50" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
//                     <h2 className='work'>Explore Our Popular Destinations</h2>
//                     <p style={{color:'white'}}>One site <span class="count-text plus" data-speed="3000" data-stop="34500">0</span> most popular experience you’ll remember</p>
//                 </div>
//             </div>
//         </div>
//         <div class="row gap-10 row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-2 justify-content-center">
//             <div class="col">
//                 <div class="destination-item style-two" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
//                     <div class="image">
//                         <img src="https://images.pexels.com/photos/10980772/pexels-photo-10980772.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Destination"/>
//                     </div>
//                     <div class="content">
//                         <h6><a href="/Destination">Switzerland's</a></h6>
//                         <span class="tours">258 tours</span>
//                     </div>
//                 </div>    
//             </div>
//             <div class="col">
//                 <div class="destination-item style-two" data-aos="fade-up" data-aos-delay="50" data-aos-duration="1500" data-aos-offset="50">
//                     <div class="image">
//                         <img src="https://images.pexels.com/photos/12573639/pexels-photo-12573639.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Destination"/>
//                     </div>
//                     <div class="content">
//                         <h6><a href="/Destination">Poland</a></h6>
//                         <span class="tours">258 tours</span>
//                     </div>
//                 </div>
//             </div>
//             <div class="col">
//                 <div class="destination-item style-two" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1500" data-aos-offset="50">
//                     <div class="image">
//                         <img src="https://images.pexels.com/photos/8557436/pexels-photo-8557436.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Destination"/>
//                     </div>
//                     <div class="content">
//                         <h6><a href="/Destination">Indonesia</a></h6>
//                         <span class="tours">258 tours</span>
//                     </div>
//                 </div>
//             </div>
//             <div class="col">
//                 <div class="destination-item style-two" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1500" data-aos-offset="50">
//                     <div class="image">
//                         <img src="https://images.pexels.com/photos/10161581/pexels-photo-10161581.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Destination"/>
//                     </div>
//                     <div class="content">
//                         <h6><a href="/Destination">Thailand</a></h6>
//                         <span class="tours">258 tours</span>
//                     </div>
//                 </div>
//             </div>
//             <div class="col">
//                 <div class="destination-item style-two" data-aos="fade-up" data-aos-delay="150" data-aos-duration="1500" data-aos-offset="50">
//                     <div class="image">
//                         <img src="https://images.pexels.com/photos/8405819/pexels-photo-8405819.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Destination"/>
//                     </div>
//                     <div class="content">
//                         <h6><a href="/Destination">Rome, Italy</a></h6>
//                         <span class="tours">258 tours</span>
//                     </div>
//                 </div>
//             </div>
//             <div class="col">
//                 <div class="destination-item style-two" data-aos="fade-up" data-aos-delay="150" data-aos-duration="1500" data-aos-offset="50">
//                     <div class="image">
//                         <img src="https://images.pexels.com/photos/9496976/pexels-photo-9496976.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Destination"/>
//                     </div>
//                     <div class="content">
//                         <h6><a href="/Destination">New York</a></h6>
//                         <span class="tours">258 tours</span>
//                     </div>
//                 </div>
//             </div>
//             <div class="col">
//                 <div class="destination-item style-two" data-aos="fade-up" data-aos-delay="150" data-aos-duration="1500" data-aos-offset="50">
//                     <div class="image">
//                         <img src="https://images.pexels.com/photos/3087240/pexels-photo-3087240.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Destination"/>
//                     </div>
//                     <div class="content">
//                         <h6><a href="/Destination">Poland</a></h6>
//                         <span class="tours">258 tours</span>
//                     </div>
//                 </div>
//             </div>
//             <div class="col">
//                 <div class="destination-item style-two" data-aos="fade-up" data-aos-delay="150" data-aos-duration="1500" data-aos-offset="50">
//                     <div class="image">
//                         <img src="https://images.pexels.com/photos/14902201/pexels-photo-14902201.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Destination"/>
//                     </div>
//                     <div class="content">
//                         <h6><a href="/Destination">Wroclaw, Poland</a></h6>
//                         <span class="tours">258 tours</span>
//                     </div>
//                 </div>
//             </div>
//             <div class="col">
//                 <div class="destination-item style-two" data-aos="fade-up" data-aos-delay="150" data-aos-duration="1500" data-aos-offset="50">
//                     <div class="image">
//                         <img src="https://images.pexels.com/photos/28359077/pexels-photo-28359077/free-photo-of-the-capitol-washington-d-c.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Destination"/>
//                     </div>
//                     <div class="content">
//                         <h6><a href="/Destination">France, Paris</a></h6>
//                         <span class="tours">258 tours</span>
//                     </div>
//                 </div>
//             </div>
//             <div class="col">
//                 <div class="destination-item style-two" data-aos="fade-up" data-aos-delay="150" data-aos-duration="1500" data-aos-offset="50">
//                     <div class="image">
//                         <img src="https://images.pexels.com/photos/3728022/pexels-photo-3728022.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Destination"/>
//                     </div>
//                     <div class="content">
//                         <h6><a href="/Destination">Antalya, Turkey</a></h6>
//                         <span class="tours">258 tours</span>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     </div>
// </section>
// <section class="hotel-area bgc-black pt-100 pb-70 rel z-1">
//     <div class="container">
//         <div class="row justify-content-between align-items-center pb-40">
//             <div class="col-lg-9">
//                 <div class="section-title text-white counter-text-wrap mb-15" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
//                     <h2>Discover the World's Class Top Hotel</h2>
//                     <p>One site <span class="count-text plus" data-speed="3000" data-stop="34500">0</span> most popular experience you’ll remember</p>
//                 </div>
//             </div>
//             <div class="col-lg-3 text-xl-end">
//                 <a href="/" class="theme-btn style-four mb-15">
//                     <span data-hover="Explore More Hotel">Explore More Hotel</span>
//                     <i class="fal fa-arrow-right"></i>
//                 </a>
//             </div>
//         </div>
//     </div>
//     <div class="container-fluid">
//         <div class="row justify-content-center">
//             <div class="col-xxl-6 col-xl-8 col-lg-10">
//                 <div class="destination-item style-three" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
//                     <div class="image">
//                         <div class="ratting"><i class="fas fa-star"></i> 4.8</div>
//                         <a href="#" class="heart"><i class="fas fa-heart"></i></a>
//                         <img src="https://images.pexels.com/photos/2291340/pexels-photo-2291340.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Hotel"/>
//                     </div>
//                     <div class="content">
//                         <span class="location"><i class="fal fa-map-marker-alt"></i> Ao Nang, Thailand</span>
//                         <h5><a href="/">The brown bench near swimming pool Hotel</a></h5>
//                         <ul class="list-style-one">
//                             <li><i class="fal fa-bed-alt"></i> 2 Bed room</li>
//                             <li><i class="fal fa-hat-chef"></i> 1 kitchen</li>
//                             <li><i class="fal fa-bath"></i> 2 Wash room</li>
//                             <li><i class="fal fa-router"></i> Internet</li>
//                         </ul>
//                         <div class="destination-footer">
//                             <span class="price"><span>$85.00</span>/per night</span>
//                             <a href="/" class="read-more">Book Now <i class="fal fa-angle-right"></i></a>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div class="col-xxl-6 col-xl-8 col-lg-10">
//                 <div class="destination-item style-three" data-aos="fade-up" data-aos-delay="50" data-aos-duration="1500" data-aos-offset="50">
//                     <div class="image">
//                         <div class="ratting"><i class="fas fa-star"></i> 4.8</div>
//                         <a href="#" class="heart"><i class="fas fa-heart"></i></a>
//                         <img src="https://images.pexels.com/photos/2446556/pexels-photo-2446556.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Hotel"/>
//                     </div>
//                     <div class="content">
//                         <span class="location"><i class="fal fa-map-marker-alt"></i> Kigali, Rwanda</span>
//                         <h5><a href="/">Green trees and body of water Marriott Hotel</a></h5>
//                         <ul class="list-style-one">
//                             <li><i class="fal fa-bed-alt"></i> 2 Bed room</li>
//                             <li><i class="fal fa-hat-chef"></i> 1 kitchen</li>
//                             <li><i class="fal fa-bath"></i> 2 Wash room</li>
//                             <li><i class="fal fa-router"></i> Internet</li>
//                         </ul>
//                         <div class="destination-footer">
//                             <span class="price"><span>$85.00</span>/per night</span>
//                             <a href="/" class="read-more">Book Now <i class="fal fa-angle-right"></i></a>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div class="col-xxl-6 col-xl-8 col-lg-10">
//                 <div class="destination-item style-three" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
//                     <div class="content">
//                         <span class="location"><i class="fal fa-map-marker-alt"></i> Ao Nang, Thailand</span>
//                         <h5><a href="/">Painted house surrounded with trees Hotel</a></h5>
//                         <ul class="list-style-one">
//                             <li><i class="fal fa-bed-alt"></i> 2 Bed room</li>
//                             <li><i class="fal fa-hat-chef"></i> 1 kitchen</li>
//                             <li><i class="fal fa-bath"></i> 2 Wash room</li>
//                             <li><i class="fal fa-router"></i> Internet</li>
//                         </ul>
//                         <div class="destination-footer">
//                             <span class="price"><span>$85.00</span>/per night</span>
//                             <a href="/" class="read-more">Book Now <i class="fal fa-angle-right"></i></a>
//                         </div>
//                     </div>
//                     <div class="image">
//                         <div class="ratting"><i class="fas fa-star"></i> 4.8</div>
//                         <a href="#" class="heart"><i class="fas fa-heart"></i></a>
//                         <img src="https://images.pexels.com/photos/1535893/pexels-photo-1535893.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Hotel"/>
//                     </div>
//                 </div>
//             </div>
//             <div class="col-xxl-6 col-xl-8 col-lg-10">
//                 <div class="destination-item style-three" data-aos="fade-up" data-aos-delay="50" data-aos-duration="1500" data-aos-offset="50">
//                     <div class="content">
//                         <span class="location"><i class="fal fa-map-marker-alt"></i> Ao Nang, Thailand</span>
//                         <h5><a href="/">house pool Jungle Pool Indonesia Hotel</a></h5>
//                         <ul class="list-style-one">
//                             <li><i class="fal fa-bed-alt"></i> 2 Bed room</li>
//                             <li><i class="fal fa-hat-chef"></i> 1 kitchen</li>
//                             <li><i class="fal fa-bath"></i> 2 Wash room</li>
//                             <li><i class="fal fa-router"></i> Internet</li>
//                         </ul>
//                         <div class="destination-footer">
//                             <span class="price"><span>$85.00</span>/per night</span>
//                             <a href="/" class="read-more">Book Now <i class="fal fa-angle-right"></i></a>
//                         </div>
//                     </div>
//                     <div class="image">
//                         <div class="ratting"><i class="fas fa-star"></i> 4.8</div>
//                         <a href="#" class="heart"><i class="fas fa-heart"></i></a>
//                         <img src="https://images.pexels.com/photos/5665396/pexels-photo-5665396.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Hotel"/>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     </div>
// </section>
// <Letter/>
// </div>
//     </div>
//   )
// }
// export default Destination











/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



import React from 'react';
import Letter from '../Newsletter/Letter';
import Query from '../Popup_Query/Query';
import { useNavigate } from "react-router-dom";
import aus from './aus.jpg';
import sheng from './schengen.jpg';
import turk from './turkey (2).jpg'

const destinations = [
    {
      name: "Canada",
      tours: 300,
      image: "https://images.pexels.com/photos/2387868/pexels-photo-2387868.jpeg?auto=compress&cs=tinysrgb&w=600",
      page_link: "/Canada_visa"
    },
    {
        name: "USA",
        tours: 500,
        image: "https://images.pexels.com/photos/887849/pexels-photo-887849.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        page_link: "/USA_visa"
    },
    {
      name: "United Kingdom",
      tours: 220,
      image: "https://images.pexels.com/photos/77171/pexels-photo-77171.jpeg?auto=compress&cs=tinysrgb&w=600",
      page_link: "/Uk_visa"
    },

    {
      name: "Schengen",
      tours: 400,
      image: sheng,
      page_link: "/Shengen_visa"
    },
    {
      name: "Turkey",
      tours: 275,
      image: turk,
      page_link: "/Turkey_visa"
    },
    {
        name: "Australia",
        tours: 180,
        image: aus,
        page_link: "/Australia_visa"
    },
  ];
  

// const DestinationItem = ({ name, tours, image }) => (
//   <div className="col">
//     <div className="destination-item style-two" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
//       <div className="image">
//         <img src={image} alt={name} />
//       </div>
//       <div className="content">
//         <h6><a href="/Destination">{name}</a></h6>
//         <span className="tours">{tours} tours</span>
//       </div>
//     </div>
//   </div>
// );


const DestinationItem = ({ name, tours, image, link }) => {
    const navigate = useNavigate();
  
    const handleClick = () => {
      navigate(link);
    };
    
    console.log(image);
    return (
  <div className="col" >
    <div className="destination-item style-two"  data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50"  onClick={handleClick}   style={{ cursor: "pointer" }}>
      <div className="image">
      <img src={image} alt={name} style={{ maxHeight: '330px',maxWidth:"100%"}}  />
      </div>
      <div className="content">
        <h6><a href="/Destination">{name}</a></h6>
        <span className="tours">{tours} tours</span>
      </div>
    </div>
  </div>
    );
  };



const Destination = () => {
  return (
    <div>
      <Query />
      <section
        className="page-banner-area pt-50 pb-35 rel z-1 bgs-cover"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1497302347632-904729bc24aa?q=80&w=2070&auto=format&fit=crop')" }}
      >
        <div className="container">
          <div className="banner-inner text-white mb-50">
            <h2 className="page-title mb-10" data-aos="fade-left" data-aos-duration="1500" data-aos-offset="50">
              Destination
            </h2>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-center mb-20" data-aos="fade-right" data-aos-delay="200" data-aos-duration="1500" data-aos-offset="50">
                <li className="breadcrumb-item"><a href="/">Home</a></li>
                <li className="breadcrumb-item active">Destination</li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      
      <section className="destinations-page-area pt-95 pb-90 rel z-1">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="section-title text-center counter-text-wrap mb-50" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
                <h2 className='work'>Explore Our Popular Destinations</h2>
                <p style={{ color: 'white' }}>
                  One site <span className="count-text plus" data-speed="3000" data-stop="34500">0</span> most popular experience you’ll remember
                </p>
              </div>
            </div>
          </div>


          <div className="row gap-16 row-cols-xl-5 mt-20 row-cols-lg-4 row-cols-md-3 row-cols-2 justify-content-center">
            {destinations.map((destination, index) => (
              <DestinationItem  
            //   style={{ maxHeight: '400px' }}
                key={index}
                name={destination.name}
                tours={destination.tours}
                image={destination.image}
                link={destination.page_link}
              />
            ))}
          </div>


        </div>
      </section>


      <section className="hotel-area bgc-black pt-100 pb-70 rel z-1">
        <div className="container">
          <div className="row justify-content-between align-items-center pb-40">
            <div className="col-lg-9">
              <div className="section-title text-white counter-text-wrap mb-15" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
                <h2>Discover the World's Class Top Hotel</h2>
                <p>One site <span className="count-text plus" data-speed="3000" data-stop="34500">0</span> most popular experience you’ll remember</p>
              </div>
            </div>
            <div className="col-lg-3 text-xl-end">
              <a href="/" className="theme-btn style-four mb-15">
                <span data-hover="Explore More Hotel">Explore More Hotel</span>
                <i className="fal fa-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row justify-content-center">
            {/* Example for one hotel item */}
            <div className="col-xxl-6 col-xl-8 col-lg-10">
              <div className="destination-item style-three" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
                <div className="image">
                  <div className="ratting"><i className="fas fa-star"></i> 4.8</div>
                  <a href="#" className="heart"><i className="fas fa-heart"></i></a>
                  <img src="https://images.pexels.com/photos/2291340/pexels-photo-2291340.jpeg" alt="Hotel" />
                </div>
                <div className="content">
                  <span className="location"><i className="fal fa-map-marker-alt"></i> Ao Nang, Thailand</span>
                  <h5><a href="/">The brown bench near swimming pool Hotel</a></h5>
                  <ul className="list-style-one">
                    <li><i className="fal fa-bed-alt"></i> 2 Bed room</li>
                    <li><i className="fal fa-hat-chef"></i> 1 kitchen</li>
                    <li><i className="fal fa-bath"></i> 2 Wash room</li>
                    <li><i className="fal fa-router"></i> Internet</li>
                  </ul>
                  <div className="destination-footer">
                    <span className="price"><span>$85.00</span>/per night</span>
                    <a href="/" className="read-more">Book Now <i className="fal fa-angle-right"></i></a>
                  </div>
                </div>
              </div>
            </div>
  




            <div class="col-xxl-6 col-xl-8 col-lg-10">
                 <div class="destination-item style-three" data-aos="fade-up" data-aos-delay="50" data-aos-duration="1500" data-aos-offset="50">
                     <div class="image">
                         <div class="ratting"><i class="fas fa-star"></i> 4.8</div>
                         <a href="#" class="heart"><i class="fas fa-heart"></i></a>
                         <img src="https://images.pexels.com/photos/2446556/pexels-photo-2446556.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Hotel"/>
                     </div>
                     <div class="content">
                         <span class="location"><i class="fal fa-map-marker-alt"></i> Kigali, Rwanda</span>
                         <h5><a href="/">Green trees and body of water Marriott Hotel</a></h5>
                         <ul class="list-style-one">
                             <li><i class="fal fa-bed-alt"></i> 2 Bed room</li>
                             <li><i class="fal fa-hat-chef"></i> 1 kitchen</li>
                             <li><i class="fal fa-bath"></i> 2 Wash room</li>
                             <li><i class="fal fa-router"></i> Internet</li>
                         </ul>
                         <div class="destination-footer">
                             <span class="price"><span>$85.00</span>/per night</span>
                             <a href="/" class="read-more">Book Now <i class="fal fa-angle-right"></i></a>
                         </div>
                     </div>
                 </div>
             </div>


             <div class="col-xxl-6 col-xl-8 col-lg-10">
                 <div class="destination-item style-three" data-aos="fade-up" data-aos-duration="1500" data-aos-offset="50">
                     <div class="content">
                         <span class="location"><i class="fal fa-map-marker-alt"></i> Ao Nang, Thailand</span>
                         <h5><a href="/">Painted house surrounded with trees Hotel</a></h5>
                         <ul class="list-style-one">
                             <li><i class="fal fa-bed-alt"></i> 2 Bed room</li>
                             <li><i class="fal fa-hat-chef"></i> 1 kitchen</li>
                             <li><i class="fal fa-bath"></i> 2 Wash room</li>
                             <li><i class="fal fa-router"></i> Internet</li>
                         </ul>
                         <div class="destination-footer">
                             <span class="price"><span>$85.00</span>/per night</span>
                             <a href="/" class="read-more">Book Now <i class="fal fa-angle-right"></i></a>
                         </div>
                     </div>
                     <div class="image">
                         <div class="ratting"><i class="fas fa-star"></i> 4.8</div>
                         <a href="#" class="heart"><i class="fas fa-heart"></i></a>
                         <img src="https://images.pexels.com/photos/1535893/pexels-photo-1535893.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Hotel"/>
                     </div>
                 </div>
             </div>



             <div class="col-xxl-6 col-xl-8 col-lg-10">
                 <div class="destination-item style-three" data-aos="fade-up" data-aos-delay="50" data-aos-duration="1500" data-aos-offset="50">
                     <div class="content">
                         <span class="location"><i class="fal fa-map-marker-alt"></i> Ao Nang, Thailand</span>
                         <h5><a href="/">house pool Jungle Pool Indonesia Hotel</a></h5>
                         <ul class="list-style-one">
                             <li><i class="fal fa-bed-alt"></i> 2 Bed room</li>
                             <li><i class="fal fa-hat-chef"></i> 1 kitchen</li>
                             <li><i class="fal fa-bath"></i> 2 Wash room</li>
                             <li><i class="fal fa-router"></i> Internet</li>
                         </ul>
                         <div class="destination-footer">
                             <span class="price"><span>$85.00</span>/per night</span>
                             <a href="/" class="read-more">Book Now <i class="fal fa-angle-right"></i></a>
                         </div>
                     </div>
                     <div class="image">
                         <div class="ratting"><i class="fas fa-star"></i> 4.8</div>
                         <a href="#" class="heart"><i class="fas fa-heart"></i></a>
                         <img src="https://images.pexels.com/photos/5665396/pexels-photo-5665396.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Hotel"/>
                     </div>
                 </div>
             </div>


  













          </div>
        </div>
      </section>
    </div>
  );
}

export default Destination;
